// src/pages/departments/CreateDepartments.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import WrapperSection from "../../components/global/WrapperSection";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import FormAddEditDepartments from "../../components/Departments/FormAddEditDepartments";

const CreateDepartments = () => {
    const navigate = useNavigate();

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditDepartments onSubmitSuccess={() => navigate("/departments")} />
        </WrapperSection>
    );
};

export default CreateDepartments;
